import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import Box from '@tds/core-box';
import Heading from '@tds/core-heading';
import Notification from '@tds/core-notification';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import AddSubscriberForm from './components/addSubscriberForm';
import VehicleInfoList from './components/subscriberList';

const RatePlansRenewal = ({
  isCorporate,
  rateplanList,
  contentfulError,
  renewalSubscriberList,
  setRenewalSubscriberList,
  setTotal,
  formErrors
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    iotOrderDetailsSection: { subscriberListHeading }
  } = localizedStrings;

  const errorMessage = _.get(formErrors, 'iotRatePlansRenewal.text', '');

  useEffect(() => {
    const subscriberTotal = renewalSubscriberList.reduce(
      (acc, current) => acc + +current.price,
      0
    );
    setTotal(previousValue => ({
      ...previousValue,
      subscriberList: subscriberTotal
    }));
  }, [renewalSubscriberList.length]);

  return (
    <>
      {contentfulError && (
        <Notification variant="error" copy="en">
          Error fetching rateplans data from contentful
        </Notification>
      )}{' '}
      {!contentfulError && rateplanList && (
        <div style={{ border: '1px solid #e3e3e3', padding: '1.5rem' }}>
          <Box between={3}>
            <Heading level="h4">{subscriberListHeading}</Heading>
            <AddSubscriberForm
              isCorporate={isCorporate}
              rateplanList={rateplanList}
              renewalSubscriberList={renewalSubscriberList}
              setRenewalSubscriberList={setRenewalSubscriberList}
            />
            {renewalSubscriberList.length > 0 && (
              <VehicleInfoList
                isCorporate={isCorporate}
                renewalSubscriberList={renewalSubscriberList}
                setRenewalSubscriberList={setRenewalSubscriberList}
              />
            )}
          </Box>
        </div>
      )}
      {errorMessage && (
        <Notification variant="error" copy="en">
          {errorMessage}
        </Notification>
      )}
    </>
  );
};

RatePlansRenewal.propTypes = {
  isCorporate: PropTypes.bool.isRequired,
  rateplanList: PropTypes.objectOf(PropTypes.any).isRequired,
  contentfulError: PropTypes.objectOf(PropTypes.any).isRequired,
  renewalSubscriberList: PropTypes.arrayOf(PropTypes.object).isRequired,
  setRenewalSubscriberList: PropTypes.func.isRequired,
  setTotal: PropTypes.func.isRequired,
  formErrors: PropTypes.shape({}).isRequired
};

export default RatePlansRenewal;
